// extracted by mini-css-extract-plugin
module.exports = {"title":"titleSecondary_title__2C9X-"};